module.exports = __webpack_public_path__ + "1_0_60/img/200 Taj Mahal.fd3abec5.jpg";